module.exports = __webpack_public_path__ + "img/tag.8b729aac.svg";